import EmptyTemplate from "backbone/projects/templates/empty.js.hamlc"

export default class EmptyProjectView extends Backbone.View
  render: ->
    @$el.html EmptyTemplate
    this



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/empty_project_view.js.coffee